import useGetProjectPartByDocId from 'features/pPart/hooks/useGetProjectPartByDocId';
import { useGetProjectByDocId } from 'hooks/use-basicQueries';
import PropTypes from 'prop-types';
import React, {
  createContext,
  useContext,
  useMemo,
} from 'react';
import { useParams } from 'react-router-dom';

const PPartDataContext = createContext();

export default function PPartDetailProvider({ children }) {
  const { projectDocId, partDocId } = useParams();
  const {
    data: pPart,
    isLoading,
  } = useGetProjectPartByDocId({ projectDocId, pPartDocId: partDocId });
  const { data: project } = useGetProjectByDocId(projectDocId);

  const value = useMemo(() => ({
    pPart,
    project,
    projectDocId,
  }), [pPart, project, projectDocId]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <PPartDataContext.Provider value={value}>
      {children}
    </PPartDataContext.Provider>
  );
}
PPartDetailProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export const usePPartDetail = () => {
  const context = useContext(PPartDataContext);
  if (context === undefined) {
    throw new Error('usePPartDetail must be used within a PPartDetailProvider');
  }
  return context;
};
